import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { ExternalIcon } from '../../../../../../common/icons';
import { Table, Pagination, Spin } from 'antd';

import './QuickCard.css';

@inject('pagedCollectionStore')
@observer
export default class QuickCard extends Component {
  render() {
    const { pagedCollectionStore } = this.props;

    const {
      data: { color, caption, captionOne, icon, ctaLabel, rowThreshold },
      onShowDetailedClick,
      collection,
      data: { availableColumns }
    } = this.props;

    const visibleInfo = !!caption && !!captionOne && !!icon && !!ctaLabel;
    const emtpyValue = '-';

    const columns = availableColumns ? availableColumns[collection] : [];

    const collectionStoreData = pagedCollectionStore.get(this.props.namespacedCollection) || {};

    const collectionCount = (collectionStoreData || {}).sourceCount || 0;
    let tableData = (collectionStoreData || {}).framed || [];

    // se c'è un parametro di soglia, il rendering della tabella include delle righe con valori vuoti
    if (!!rowThreshold) {
      tableData = tableData.slice(0, rowThreshold);
      const tableDataLength = tableData.length;
      for (let i = 0; i < rowThreshold - tableDataLength; i++) {
        const fields = columns.map(column => column.key);
        tableData.push({
          ...Object.assign({}, ...fields.map((n, index) => ({ [n]: emtpyValue })))
        });
      }
    }

    tableData = tableData.map((data, index) => ({ ...data, key: index }));

    // la paginazione viene gestita con un componente separato
    let pagination = false;
    let paginationText = '';
    if (!rowThreshold && collectionStoreData !== {}) {
      pagination = collectionStoreData.pagination;
      const start = pagination.pageSize * (pagination.current - 1) + 1;
      const end = Math.min(pagination.total, start + pagination.pageSize - 1);
      paginationText = `${start}-${end} di ${collectionCount} ${caption}`;
    }

    return (
      <div className="QuickCard">
        <Spin spinning={collectionStoreData.loading}>
          <div className="QuickCardFrame">
            {visibleInfo && (
              <div className="QuickCardInfo">
                <div style={{ color }}>
                  {icon && <div style={{ marginRight: '10px', display: 'flex', alignItems: 'center' }}>{icon}</div>}
                  {collectionCount === 1 ? captionOne : collectionCount > 1 ? `${collectionStoreData.sourceCount} ${caption}` : caption}
                </div>
                <div>
                  <div onClick={onShowDetailedClick}>
                    <div>{ctaLabel}</div>
                    <ExternalIcon style={{ width: '12px', height: '12px' }} />
                  </div>
                </div>
              </div>
            )}

            <Table
              columns={columns}
              dataSource={tableData}
              pagination={false}
              onChange={(...params) => pagedCollectionStore.onCollectionTableChange(this.props.namespacedCollection, ...params)}
            />
          </div>
          {pagination !== false && pagination.total > pagination.pageSize && (
            <div className="QuickCardPagination">
              <div>{paginationText}</div>
              <Pagination {...pagination} />
            </div>
          )}
        </Spin>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/ClientListWithMap/ClientDetail/QuickHealth/QuickCard/QuickCard.js